<template>
  <CrudList
    title="Descuentos"
    storeName="Discounts"
    labelAddNew="Nuevo Descuento"
    slot-scope="{ item }"
    sortable
    canSearch
  >
    <template v-slot:discount="{ item }">
      <div
        style="width: 60px; height: 70%; padding: 2px 8px;background: white; border-radius: 90px; border: 1px #A6A6A6 solid; justify-content: center; align-items: center; gap: 8px; display: inline-flex"
      >
        <div
          style="text-align: center; color: #737373; font-size: 14px; font-family: Plus Jakarta Sans; font-weight: 500; line-height: 20px; word-wrap: break-word"
        >
          {{ item.discount + "%" }}
        </div>
      </div>
    </template>

    <template v-slot:quantity_limit="{ item }">
      <div>
        {{ item.quantity_limit > 0 ? item.quantity_limit : "Sin límite" }}
      </div>
    </template>

    <template v-slot:app_quantity_limit="{ item }">
      <div>
        {{ item.app_quantity_limit > 0 ? item.app_quantity_limit : "Sin límite" }}
      </div>
    </template>

    <template v-slot:app_quantity_limit_with_discount="{ item }">
      <div>
        {{ item.app_quantity_limit_with_discount > 0 ? item.app_quantity_limit_with_discount : "Sin límite" }}
      </div>
    </template>

    <template v-slot:active="{ item }">
      <v-row>
        <div style="align-content: center; width: 80px">
          {{ item.active ? "Activo" : "Inactivo" }}
        </div>

        <v-switch
          class="mt-1 mb-2"
          color="accent"
          :value="item.active"
          v-model="item.active"
          hide-details
          dense
          inset
          @change="updateItemActive(item)"
        />
      </v-row>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  methods: {
    async updateItemActive(item) {
      await this.$store.dispatch("Discounts/update", {
        id: item.id,
        active: !!item.active
      });
    }
  }
};
</script>
